<div menuSystem [cerrixTab]="tab">
    <div [attr.name]="'externalConnections.connectionOverview.thirdPartyAssurance' | transloco" class="" menuicon="fad fa-shield-alt" menuItemId="menuItemThirdPartyAssurance" menusystemitem>
        <app-tpa-overview></app-tpa-overview>
    </div>
</div>
